<template>
    <div v-if="isShowToast" class="toast-container" @touchmove.prevent>
      <span class="toast-msg">{{ content }}</span>
    </div>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
      isShowToast: true,
      content: ''
    }
  }
}
</script>

<style scoped>
  .toast-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
  }
  .toast-msg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
    background: rgba(17,17,17,0.7);
    color: #FFFFFF;
  }
</style>
